import React, { useCallback, useState } from "react"
import { StyleSheet, Text } from "react-native"
import { useDispatch } from "react-redux"

import Base, { Actions, Api } from "../../../base"
import { Alert, ExpandableButton } from "../../common"
import Collapsible from "../../common/Collapsible"
import Gap from "../../common/Gap"
import TimeSlot from "./TimeSlot"
import TimeSlotHeader from "./TimeSlotHeader"

export default function TimeSlotView(props) {
  const dispatch = useDispatch()
  const [redraw, setRedraw] = useState(0)

  async function addTimeslot(timeslot) {
    try {
      for (let i = 0; i < props.service.disabledTimeslots.length; i++) {
        const ts = props.service.disabledTimeslots[i]
        if (ts.from === timeslot.from && ts.to === timeslot.to) {
          Alert.show(
            "Hold Up",
            "You already have this timeslot disabled. Try adding a different one",
          )
          return
        }
      }
      props.setLoading("Adding Timeslot...")
      const timeslots = [...props.service.disabledTimeslots, timeslot]
      const success = await Api.updateTimeSlots(timeslots, props.service)
      if (!success || success === null) {
        Alert.show(
          "Hold Up",
          "Unable to update timeslots, please check your connection and try again.",
          "OK",
          () => {
            props.setLoading(null)
          },
        )
        return
      }
      props.setLoading(null)
      dispatch(
        Actions.setService({ ...props.service, disabledTimeslots: timeslots }),
      )
      setRedraw(redraw + 1)
    } catch (error) {
      console.log(error)
    }
  }

  async function deleteTimeSlot(timeslot) {
    try {
      const timeslots = [...props.service.disabledTimeslots]
      let index = null
      for (let i = 0; i < timeslots.length; i++) {
        const ts = props.service.disabledTimeslots[i]
        if (ts.from === timeslot.from && ts.to === timeslot.to) {
          index = i
          break
        }
      }
      if (index != null) {
        timeslots.splice(index, 1)
      }
      console.log(timeslots)

      props.setLoading("Removing Timeslot...")
      const success = await Api.updateTimeSlots(timeslots, props.service)
      if (!success || success === null) {
        Alert.show(
          "Hold Up",
          "Unable to update timeslots, please check your connection and try again.",
          "OK",
          () => {
            props.setLoading(null)
          },
        )
        return
      }
      props.setLoading(null)
      dispatch(
        Actions.setService({ ...props.service, disabledTimeslots: timeslots }),
      )
    } catch (error) {
      console.log(error)
    }
  }

  const renderHeader = useCallback(
    headerProps => <ExpandableButton title={"Timeslots"} {...headerProps} />,
    [],
  )

  if (!props.service || !props.service.disabledTimeslots) {
    return null
  }

  return (
    <Collapsible RenderHeader={renderHeader}>
      <Gap size={10} />
      <Text style={Base.styles.body}>
        You can disable your time slots by entering a start and finish time
        below. This will be reset to your standard operating hours at the end of
        each day.
      </Text>
      <Text style={styles.sectionTitle}>Disable Timeslots Between:</Text>
      <TimeSlotHeader />
      <TimeSlot onCommit={addTimeslot} />
      <Gap size={30} />
      <Text style={styles.sectionTitle}>Timeslots Currently Disabled:</Text>
      {!props.service.disabledTimeslots.length ? (
        <Text style={styles.noTimeslots}>No Timeslots set</Text>
      ) : (
        <TimeSlotHeader />
      )}
      {props.service.disabledTimeslots.map((timeslot, i) => {
        return (
          <TimeSlot key={i} timeslot={timeslot} onCommit={deleteTimeSlot} />
        )
      })}
      <Gap size={20} />
    </Collapsible>
  )
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    justifyContent: "flex-start",
    marginVertical: 4,
  },

  day: {
    width: 130,
  },

  sectionTitle: {
    marginVertical: 18,
    fontFamily: Base.fonts.appSemiBold,
    fontSize: 20,
    color: Base.colours.appDarkBlue,
  },

  noTimeslots: {
    fontFamily: Base.fonts.appRegular,
    fontSize: 16,
  },
})
